import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button, Icon, Popup, Loader } from 'semantic-ui-react'

import AppUtils from '../../utils/AppUtils'
import AppConstants from '../../utils/AppConstants'
import ColumnsProvider from '../../utils/ColumnsProvider'
import Page from '../../components/elements/Page'
import Header from '../../components/elements/Header'
import Table from '../../components/elements/Table'
import SearchField from '../../components/elements/SearchField'
import ListSelector from '../../components/elements/ListSelector'
import Properties from '../../components/elements/Properties'
import Details from '../../components/elements/Details'
import LocationStickers from '../../components/elements/LocationStickers'
import CreateInventoryPopup from '../popups/inventories/CreateInventoryPopup'
import UpdateInventoryPopup from '../popups/inventories/UpdateInventoryPopup'
import HistoryItemPopup from '../popups/items/HistoryItemPopup'
import Grant from '../elements/Grant'

import ListAction from '../../actions/inventories/ListAction'
import GetAction from '../../actions/inventories/GetAction'
import ChangePageAction from '../../actions/app/ChangePageAction'

class InventoryPage extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      // Search text of the left search field
      search: '',
      // Is editing inventory infos
      isUpdate: false,
      // Is executing an inventory
      isExecute: false,
      // ID of item currently open in history popup
      itemHistoryId: null
    }

    // Bind events
    this.onSelect = this.onSelect.bind(this)
    this.onClickExecute = this.onClickExecute.bind(this)
    this.onCloseExecute = this.onCloseExecute.bind(this)
    this.onChangeSearch = this.onChangeSearch.bind(this)
    this.onClickInventoryUpdate = this.onClickInventoryUpdate.bind(this)
    this.onCloseInventoryUpdate = this.onCloseInventoryUpdate.bind(this)
    this.onClickItemHistory = this.onClickItemHistory.bind(this)
    this.onCloseItemHistory = this.onCloseItemHistory.bind(this)
    this.onClickGoToProduct = this.onClickGoToProduct.bind(this)
  }

  fetchList() {
    this.props.fetchList()
  }

  fetchOne() {
    this.props.fetchOne(this.props.selected)
  }

  componentDidMount() {
    this.fetchList()
    if (!_.isNull(this.props.selected)) {
      this.fetchOne()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // After selecting an inventory, load details
    if (
      prevProps.selected !== this.props.selected
      &&
      !_.isNull(this.props.selected)
    ) {
      this.fetchOne()
    }
  }

  onSelect(selected) {
    this.props.changePage(AppConstants.PAGE.INVENTORY, selected)
  }

  onClickExecute() {
    this.setState({
      isExecute: true
    })
  }

  onCloseExecute(inventoryId) {
    this.setState({
      isExecute: false
    })
    if (inventoryId) {
      this.fetchList()
      this.onSelect(inventoryId)
    }
  }

  onChangeSearch(search) {
    this.setState({ search })
  }

  onClickInventoryUpdate() {
    this.setState({
      isUpdate: true
    })
  }

  onCloseInventoryUpdate(isDirty) {
    this.setState({
      isUpdate: false
    })
    if (isDirty) {
      this.fetchOne()
      this.fetchList()
    }
  }

  onClickItemHistory(itemHistoryId) {
    return () => {
      this.setState({ itemHistoryId })
    }
  }

  onCloseItemHistory() {
    this.setState({
      itemHistoryId: null
    })
  }

  onClickGoToProduct(id) {
    return () => {
      this.props.changePage(AppConstants.PAGE.PRODUCTS_VIEW, id)
    }
  }

  render() {
    const filteredList = _.isArray(this.props.listData)
      ? _.filter(
          this.props.listData,
          (inventory) => (
            AppUtils.search(inventory.title, this.state.search)
            ||
            AppUtils.search(AppUtils.displayDate(inventory.date, '?', false), this.state.search)
          )
        )
      : null
    const linearList = []
    if (this.props.listIsFetching) {
      linearList.push(
        <ListSelector.Header
          foreground='000000'
          background='ffffff'
          text='Chargement...'
        />
      )
    }
    else {
      if (_.isArray(filteredList) && _.size(filteredList) > 0) {
        _.each(filteredList, (inventory) => {
          linearList.push(
            <ListSelector.Item
              value={inventory.id}
              text={`${AppUtils.displayDate(inventory.date, '?', false)} - ${inventory.title}`}
            />
          )
        })
      }
      else {
        linearList.push(
          <ListSelector.Header
            foreground='000000'
            background='ffffff'
            text='Rien à afficher.'
          />
        )
      }
    }
    const missingItems = this.props.getData && _.isArray(this.props.getData.categories)
      ? (
          _.flatten(
            _.map(
              _.flatten(
                _.map(
                  this.props.getData.categories,
                  (category) => (category.products)
                )
              ),
              (product) => (
                _.map(
                  _.filter(
                    product.items,
                    (item) => (!item.found)
                  ),
                  (item) => (
                    _.extend(
                      {},
                      item.item,
                      {
                        number: _.isNull(product.product.prefix) ? null : `${product.product.prefix}${item.item.number}`,
                        product: _.pick(product.product, 'name')
                      }
                    )
                  )
                )
              )
            )
          )
        )
      : []
    const productsList = this.props.getData && _.isArray(this.props.getData.categories)
      ? (
          _.flatten(
            _.map(
              this.props.getData.categories,
              (category) => _.union(
                [
                  Table.headerRow(
                    category.category.name,
                    category.category.color.foreground,
                    category.category.color.background
                  )
                ],
                _.map(
                  category.products,
                  (product) => _.extend(
                    {},
                    product,
                    {
                      items: _.map(
                        product.items,
                        (item) => (_.extend(
                          {},
                          item.item,
                          {
                            number: _.isNull(product.product.prefix)
                              ? null
                              : `${product.product.prefix}${item.item.number}`,
                            found: item.found
                          }
                        ))
                      )
                    }
                  )
                )
              )
            )
          )
        )
      : null
    return (
      <React.Fragment>
        <Page direction={Page.DIRECTION.ROW}>
          <Page.Element
            flex='1 1 20%'
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <div
              style={{
                flex: '0 0 38px',
                display: 'flex',
                flexDirection: 'row'
              }}
            >
              <div style={{ flex: '0 0 auto' }}>
                <Grant role={Grant.ROLE.INVENTORY}>
                  <Popup
                    trigger={
                      <Button
                        icon='play'
                        color='green'
                        onClick={this.onClickExecute}
                        style={{ margin: 0 }}
                      />
                    }
                    inverted={true}
                    on='hover'
                    position='right center'
                  >
                    Effectuer un inventaire
                  </Popup>
                </Grant>
              </div>
              <div style={{
                flex: '1 0 auto',
                marginLeft: '8px'
              }}>
                <SearchField
                  value={this.state.search}
                  onChange={this.onChangeSearch}
                />
              </div>
            </div>
            <ListSelector
              style={{
                flex: '1 1 auto',
                marginTop: '8px'
              }}
              selected={this.props.selected}
              onSelect={this.onSelect}
              children={linearList}
            />
          </Page.Element>
          <Page.Container
            flex='4 4 80%'
            direction={Page.DIRECTION.COL}
          >
            {
              !_.isNull(this.props.selected)
                ? (
                    this.props.getIsFetching || !this.props.getData
                      ? <Page.Element
                          flex='1 1 100%'
                        >
                          <Loader
                            active={true}
                            content='Chargement...'
                            size='huge'
                          />
                        </Page.Element>
                      : <React.Fragment>
                          <Page.Element
                            flex='0 0 auto'
                            withBorders={true}
                          >
                            <Header
                              title="Description de l'inventaire"
                              right={
                                <Grant role={Grant.ROLE.MANAGE}>
                                  <Button
                                    compact={true}
                                    icon='pencil'
                                    color='orange'
                                    onClick={this.onClickInventoryUpdate}
                                  />
                                </Grant>
                              }
                              alignTop={true}
                            />
                            <Properties
                              content={[
                                {
                                  key: 'Date',
                                  value: AppUtils.displayDate(this.props.getData.date)
                                },
                                {
                                  key: 'Titre',
                                  value: this.props.getData.title
                                },
                                {
                                  key: 'Emplacement',
                                  value: (
                                    <LocationStickers
                                      stickers={this.props.getData.location.stickers}
                                    />
                                  )
                                },
                                {
                                  key: 'Saisi par',
                                  value: this.props.getData.user.name
                                },
                                {
                                  key: 'Participants',
                                  value: this.props.getData.people
                                },
                                {
                                  key: 'Résultat',
                                  value: (
                                    _.size(missingItems) === 0
                                      ? <React.Fragment>
                                          <Icon
                                            name='checkmark'
                                            color='green'
                                          />
                                          {' Toutes les pièces ont été trouvées'}
                                        </React.Fragment>
                                      : <React.Fragment>
                                          <Details
                                            icon={Details.ICON.FAILURE}
                                            action={Details.ACTION.CLICK}
                                            content={
                                              <div style={{
                                                width: '700px',
                                                maxHeight: '320px',
                                                display: 'flex',
                                                flexDirection: 'column'
                                              }}>
                                                <Table
                                                  columns={[
                                                    // N°
                                                    ColumnsProvider.itemNumberFull,
                                                    // Matériel
                                                    ColumnsProvider.itemProduct,
                                                    // Emplacement
                                                    ColumnsProvider.locationStickers,
                                                    // Compartiment
                                                    ColumnsProvider.itemCompartmentBasic,
                                                    // Action
                                                    ColumnsProvider.itemActions(false, this.onClickItemHistory)
                                                  ]}
                                                  data={missingItems}
                                                  error={null}
                                                  isLoading={false}
                                                  emptyMessage="Aucune pièce manquante."
                                                  float={true}
                                                />
                                              </div>
                                            }
                                          />
                                          {` ${_.size(missingItems)} pièce${_.size(missingItems) > 1 ? 's' : ''} manquante${_.size(missingItems) > 1 ? 's' : ''}`}
                                        </React.Fragment>
                                  )
                                },
                                {
                                  key: 'Remarque',
                                  value: this.props.getData.remark
                                }
                              ]}
                            />
                          </Page.Element>
                          <Page.Element
                            flex='1 1 auto'
                            withBorders={true}
                            style={{
                              display: 'flex',
                              flexDirection: 'column'
                            }}
                          >
                            <Header
                              style={{
                                flex: '0 0 auto'
                              }}
                              title="Contenu de l'inventaire"
                            />
                            <Table
                              columns={[
                                // Matériel
                                ColumnsProvider.itemProduct,
                                // Supposé
                                ColumnsProvider.inventoryProductExpected,
                                // Trouvé
                                ColumnsProvider.inventoryProductFound,
                                // Status
                                ColumnsProvider.inventoryProductStatus(this.onClickItemHistory),
                                // Action
                                ColumnsProvider.actionGoTo(this.onClickGoToProduct, 'product.id')
                              ]}
                              data={productsList}
                              error={null}
                              isLoading={false}
                              emptyMessage="Aucun matériel concerné par cet inventaire."
                            />
                          </Page.Element>
                        </React.Fragment>
                  )
                : null
            }
          </Page.Container>
        </Page>
        {
          this.state.isExecute
            ? <CreateInventoryPopup
                onClose={this.onCloseExecute}
              />
            : null
        }
        {
          this.state.isUpdate && !_.isNull(this.props.selected)
            ? <UpdateInventoryPopup
                id={this.props.selected}
                onClose={this.onCloseInventoryUpdate}
              />
            : null
        }
        {
          !_.isNull(this.state.itemHistoryId) && !_.isNull(this.props.selected)
            ? <HistoryItemPopup
                id={this.state.itemHistoryId}
                onClose={this.onCloseItemHistory}
              />
            : null
        }
      </React.Fragment>
    )
  }
}

InventoryPage.propTypes = {
  // Properties

  // Redux State
  selected: PropTypes.number,
  listData: PropTypes.array,
  listIsFetching: PropTypes.bool.isRequired,
  listError: PropTypes.object,
  getData: PropTypes.object,
  getIsFetching: PropTypes.bool.isRequired,
  getError: PropTypes.object,

  // Redux Actions
  fetchList: PropTypes.func.isRequired,
  fetchOne: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    selected: state.entities.inventories.view,
    listData: state.entities.inventories.list.data,
    listIsFetching: state.entities.inventories.list.isFetching,
    listError: state.entities.inventories.list.error,
    getData: state.entities.inventories.get.data,
    getIsFetching: state.entities.inventories.get.isFetching,
    getError: state.entities.inventories.get.error
  }),
  (dispatch) => ({
    fetchList: () => (dispatch(ListAction({}))),
    fetchOne: (id) => (dispatch(GetAction({ id }))),
    changePage: (page, id=undefined) => (dispatch(ChangePageAction(page, { id })))
  })
)(InventoryPage)



// WEBPACK FOOTER //
// ./src/containers/pages/InventoryPage.js